import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Slider from "react-slick";
import { SvgAssets } from '../../../assets/icons/iconSvg';
import c from '../../../constants/Colors';
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';

const ModalImageZoom2 = (item) => {
    const VISIBLE = item.dadComponent.state.modalZoom; 
    const TOGGLE_MODAL = item.dadComponent['toggleModalZoom'];
    const IMAGE = item.dadComponent.state.imgZoom;
    const listImgRepuestos = item.dadComponent.state.listImgZoom;
    
    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <div>
            <Modal isOpen={VISIBLE} toggle={TOGGLE_MODAL} className='modal_zoom' centered backdrop="static">
                <button className="btn-icon modal-close" onClick={TOGGLE_MODAL}><SvgAssets icon="icon-close" fill={c.celeste} /></button>
                <Slider {...settings}>
                    {
                       (listImgRepuestos != null && listImgRepuestos.length && Array.isArray(listImgRepuestos) > 0) ? listImgRepuestos.map((data,index)=>{
                           return(
                            <div key={index}>
                                <InnerImageZoom src={data} zoomSrc={data}/>
                            </div>)
                        }): 
                        (
                            <div>
                                <InnerImageZoom src={IMAGE} zoomSrc={IMAGE}/>
                            </div>
                        )
                    }
                </Slider>
                
            </Modal>
        </div>
    )
}

export default ModalImageZoom2;